import labelGeral from '$/Labels'

const labels = []

labels['exercicioLabel'] = 'Exercício'
labels['mesLabel'] = 'Mês'
labels['grupoLabel'] = 'Grupo'
labels['administracaoLabel'] = labelGeral.administracao
labels['recursosVinculadosLabel'] = 'Recurso'
labels['recursosDestinacaoLabel'] = 'Destinação'
labels['tipoRecursosLabel'] = 'Tipo Recurso'
labels['filtrosLabel'] = 'Filtros'
labels['grau'] = 'Nível da Receita'

labels['janeiro'] = 'Janeiro'
labels['fevereiro'] = 'Fevereiro'
labels['marco'] = 'Março'
labels['abril'] = 'Abril'
labels['maio'] = 'Maio'
labels['junho'] = 'Junho'
labels['julho'] = 'Julho'
labels['agosto'] = 'Agosto'
labels['setembro'] = 'Setembro'
labels['outubro'] = 'Outubro'
labels['novembro'] = 'Novembro'
labels['dezembro'] = 'Dezembro'

labels['administracao.placeholder'] = 'Busque por ' + labelGeral.administracao
labels['recursosVinculados.placeholder'] = 'Busque por recurso'
labels['recursosDestinacao.placeholder'] = 'Busque por destinação'
labels['tipoRecursos.placeholder'] = 'Busque por Tipo Recurso'

labels['removerFitlroAplicado'] = 'Remover filtro'
labels['atualizarFiltro'] = 'Atualizar'

labels['criteriosAtualizados'] = ''

export default labels
